import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { getAllRoleIds } from "./Services/EnterUserSer";

import axios from "axios";
const UserType = () => {
  const [userType, setUserType] = useState([]);
  const [roleIds, setRoleIds] = useState([]);
  const [userTypeName, setUserTypeName] = useState('');
  const [ids, setIds] = useState(null);
  const [editUserTypeName, setEditUserTypeName] = useState('');  // For editing
  const [selectedUserType, setSelectedUserType] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  useEffect(() => {
    const scriptUrls = [
      'assets/js/jquery.min.js',
      'assets/js/bootstrap.bundle.min.js',
      'assets/js/moment.min.js',
      'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
      'assets/vendor/overlay-scroll/custom-scrollbar.js',
      'assets/vendor/daterange/daterange.js',
      'assets/vendor/daterange/custom-daterange.js',
      'assets/vendor/jquery-ui/jquery-ui.min.js',
      'assets/vendor/jquery-ui/custom.js',
      'assets/vendor/datatables/dataTables.min.js',
      'assets/vendor/datatables/dataTables.bootstrap.min.js',
      'assets/vendor/datatables/custom/custom-datatables.js',
      'assets/js/custom.js'
    ];

    let isCancelled = false;

    // Load scripts sequentially
    const loadScriptsSequentially = async () => {
      for (const url of scriptUrls) {
        if (isCancelled) break;

        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.onload = resolve;
          script.onerror = reject;
          document.body.appendChild(script);
        });
      }
    };

    loadScriptsSequentially();

    return () => {
      isCancelled = true;
      // Optionally remove scripts if needed
    };
  }, []);




  const navigator = useNavigate();

  function handleEnter(e) {
    e.preventDefault();

    const formData = new FormData();

    formData.append("jsonData", JSON.stringify({

      "userTypeName": userTypeName,


    }));


  }


  const handleUpdateClick = (e, id) => {
    e.preventDefault();
    // Navigate to /page2 and pass the value
    navigator('/edit-departments', { state: { uata: id } });

    window.location.reload();
  };

  const handleDeleteClick = (e, id) => {
    e.preventDefault();
    // Deletes the department

    const REST_API_BASE_URL = `http://localhost:8080/webnet-hms/api/user-types/${id}`;

    axios.delete(REST_API_BASE_URL)
      .then((response) => {
        console.log(response.data);
        window.alert(`The usertype is deleted: ${response.data}`);
        fetchUserTypes();

        // After deletion, redirect to another page (e.g., home or item list)
        //navigator("/userType-list"); // Navigates back to the homepage or another route

      })
      .catch((error) => {
        window.alert("Error occurred while deleting the item.");
        console.error(error);
      });
  };
  const handleDeleteAll = (e) => {
    e.preventDefault();
    // Show confirmation dialog
    const confirmDelete = window.confirm(
      `Are you sure you want to delete all items?`
    );

    if (confirmDelete) {
      // If confirmed, perform the delete action
      const REST_API_BASE_URL = `http://localhost:8080/webnet-hms/api/user-types`;


      axios
        .post(REST_API_BASE_URL)
        .then((response) => {
          console.log(response.data);
          window.alert(`This happend with: ${response.data}`);

          // After deletion, redirect to another page (e.g., home or item list)
          navigator("/departments-list"); // Navigates back to the homepage or another route
        })
        .catch((error) => {
          window.alert("Error occurred while deleting the item.");
          console.error(error);
        });
    } else {
      // If cancelled, do nothing (or show a cancellation message)
      window.alert("Deletion cancelled");
      navigator("/departments-list");
    }
  }



  const srcImg = "http://localhost:8080/Images/";
  useEffect(() => {
    const REST_API_BASE_URL = `http://localhost:8080/webnet-hms/api/user-types`;
    const listDoctorUser = () => axios.get(REST_API_BASE_URL);
    listDoctorUser().then((response) => {
      setUserType(response.data);

    }).catch(error => {
      console.error(error);
    })
  }, [])


  function handleCancelUserType(e) {
    e.preventDefault();
    let divPanel = document.getElementById('divPanel')
    divPanel.style.display = "none";
    let divButtons = document.getElementById('cancel')
    divButtons.style.display = "none";

    let addButtons = document.getElementById('add')
    addButtons.style.display = "block";


  }
  function addUserTypePanel(e) {
    e.preventDefault();
    let divPanel = document.getElementById('divPanel')
    divPanel.style.display = "block";

    let divButtons = document.getElementById('cancel')
    divButtons.style.display = "block";
    let addButtons = document.getElementById('add');
    addButtons.style.display = "none";


  }

  const toSentenceCase = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };
  const userData = {
    rolesId: parseInt(userType)
  };
  useEffect(() => {
    // Fetch role IDs
    getAllRoleIds()
      .then((res) => {
        setRoleIds(res.data);
      })
      .catch((err) => {
        console.error("Error fetching role IDs:", err);
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prepare the data to be sent in the POST request
    const newUserType = {
      userTypeName  // This will capture the user type name from the state
    };

    try {
      // Make a POST request to add the new user type to the backend
      const response = await axios.post("http://localhost:8080/webnet-hms/api/user-types", newUserType);

      // If successful, alert the user and clear the input field
      alert("User Type Added Successfully!");
      setUserTypeName("");  // Clear the input field
      fetchUserTypes();

      // Optionally, you can reload the user type list or take other actions here
      // For example, you could call the function to fetch the updated list of user types:
      // fetchUserTypes();
    } catch (error) {
      console.error("Error adding user type:", error);
      alert("Error adding user type.");
    }
  };

  // useEffect(() => {
  //   // Fetch user types from backend when the component mounts
  //   axios
  //     .get("http://localhost:8080/api/user-types") // Replace with your backend API URL
  //     .then((response) => {
  //       // Set the fetched data to state
  //       setUserType(response.data); // Assuming response.data is an array of user types
  //     })
  //     .catch((error) => {
  //       console.error("There was an error fetching the data!", error);
  //     });
  // }, []);
  const fetchUserTypes = () => {
    axios
      .get("http://localhost:8080/webnet-hms/api/user-types")
      .then((response) => {
        setUserType(response.data);
      })
      .catch((error) => {
        console.error("Error fetching user types:", error);
      });
  };

  useEffect(() => {
    fetchUserTypes();
  }, []);


  const handleEditUserType = (e, id) => {
    e.preventDefault();
    const userTypeToEdit = userType.find((user) => user.userTypeId === id);
    // console.log(userTypeToEdit)1 === 1 true

    if (userTypeToEdit) {
      setSelectedUserType(userTypeToEdit);
      setEditUserTypeName(userTypeToEdit.userTypeName);
    }
  };

  const handleUpdateUserType = async (e) => {
    e.preventDefault();

    if (!selectedUserType) {
      alert("Please select a user type to update.");
      return;
    }

    const updatedUserType = {
      userTypeId: selectedUserType.userTypeId,
      userTypeName: editUserTypeName,
    };

    try {
      const response = await axios.put(
        `http://localhost:8080/webnet-hms/api/user-types/${selectedUserType.userTypeId}`,
        updatedUserType
      );

      if (response.status === 200) {
        alert("User Type Updated Successfully!");

        // Refresh the list after successful update
        fetchUserTypes();

        // Clear the edit state
        setEditUserTypeName('');
        setSelectedUserType(null);
      } else {
        alert("Failed to update user type.");
      }
    } catch (error) {
      console.error("Error updating user type:", error);
      alert("Error updating user type.");
    }
  };





  return (

    <div>
      {/* App hero header starts */}
      <div className="app-hero-header d-flex align-items-center">
        {/* Breadcrumb starts */}

        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="index-2.html">
              <i className="ri-home-3-line" />
            </a>
          </li>

          <li className="breadcrumb-item">UsersType</li>
          <li className="breadcrumb-item text-primary" aria-current="page">
            Add UsersType

          </li>
        </ol>
        {/* Breadcrumb ends */}
        {/* Sales stats starts */}

        {/* <div className="ms-auto d-lg-flex d-none flex-row">
     
      {/* Sales stats ends */}
      </div>
      {/* App Hero header ends */}
      {/* App body starts */}
      <div className="app-body">
        {/* Row starts */}
        <div className="row gx-4">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                {/* Custom tabs starts */}
                <div className="custom-tabs-container">
                  {/* Nav tabs starts */}

                  {/* Nav tabs ends */}
                  {/* Tab content starts */}
                  <div className="tab-content h-350" style={{ paddingTop: "0.5rem;" }}>

                    <div className="tab-pane fade show active" id="twoA" role="tabpanel">
                      {/* Row starts */}
                      <div className="row justify-content-left">
                        <div className="col-sm-12 col-12" id="divPanel" style={{ display: "none" }}>
                          <div className="card border mb-3">
                            <div className=" card-body ">
                              <form onSubmit={handleSubmit}>
                                <div className="row align-items-end g-3">


                                  <div className="col-md-4">
                                    <label className="form-label" htmlFor="a2">UserType</label>

                                    <input
                                      type="text"
                                      className="form-control"
                                      id="a2"

                                      placeholder="UserType"
                                      onChange={(e) => setUserTypeName(e.target.value)}
                                      value={userTypeName}
                                    />
                                  </div>

                                  <div className="col-md-4 d-flex align-items-end justify-content-end">
                                    <button type="submit" className="btn btn-primary"  >
                                      Add UsersType
                                    </button>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>

                        </div>
                        {/*  */}

                        {/* d-flex gap-2 */}

                      </div>
                      {/* Row ends */}
                      <div className="card border">

                        <div className="card-body pt-15">
                          {/* Table starts */}

                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="card-title mb-0">UserType List</h5>

                            <div>
                              <button type="button" id="cancel" className="btn btn-primary me-2" style={{ display: "none" }} onClick={handleCancelUserType}>
                                Cancel
                              </button>
                              <button type="button" id="add" className="btn btn-primary" onClick={addUserTypePanel}>
                                Add
                              </button>
                            </div>
                          </div>


                          <div className="table-responsive">
                            <table id="basicExample" className="table m-0 align-middle">
                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th>User Types</th>
                                  {/* <th>Department Head</th> */}
                                  {/* <th>Doctors List</th> */}
                                  <th>Actions</th>
                                </tr>
                              </thead><tbody>
                                {userType.map((userType, index) => (
                                  <tr key={userType.id}>
                                    <td>{index + 1}</td>
                                    <td>{toSentenceCase(userType.userTypeName)}</td>
                                    <td>
                                      <div className="d-inline-flex gap-1">
                                       
                                        <button
                                          className="btn btn-outline-success btn-sm"
                                          data-bs-toggle="modal"
                                          data-bs-target="#editModules"
                                          data-bs-title="Edit"
                                          onClick={(e) => handleEditUserType(e, userType.userTypeId)}

                                        >
                                          <i className="ri-edit-box-line" />
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          {/* Table ends */}
                          {/* Modal Delete Row */}
                          <div className="modal fade" id="delRow" tabIndex={-1} aria-labelledby="delRowLabel" aria-hidden="true">
                            <div className="modal-dialog modal-sm">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title" id="delRowLabel">
                                    Confirm
                                  </h5>
                                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                </div>
                                <div className="modal-body">
                                  Are you sure you want to delete the doctor from list?
                                </div>
                                <div className="modal-footer">
                                  <div className="d-flex justify-content-end gap-2">
                                    <button className="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close">No</button>
                                    <button className="btn btn-danger" data-bs-dismiss="modal" aria-label="Close" onClick={(e) => handleDeleteClick(e, deleteId)}>Yes</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* Modal Delete Row */}
                          {/* edit row */}
                          <div className="modal fade" id="editModules" tabIndex={-1} aria-labelledby="editModulesLabel" aria-hidden="true">
                            <div className="modal-dialog modal-md">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title" id="iconRowLabel">
                                    Edit
                                  </h5>
                                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                </div>
                                <div className="modal-body">
                                  <div className="row justify-content-left">
                                    <div className="col-sm-12 col-12" id="divPanel">

                                      <div className="card border mb-3">
                                        <div className="card-body">

                                          <div className="row gx-4">
                                        

                                            <div className=" col-sm-6 col-12">
                                              <div className="mb-3">
                                                <label className="form-label" htmlFor="a1">User Type</label>
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  id="a1"
                                                  placeholder="Enter UsersType"
                                                  name="userType"
                                                  value={editUserTypeName}
                                                  onChange={(e) => setEditUserTypeName(e.target.value)}
                                                  required
                                                />

                                              </div>
                                            </div>

                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="modal-footer">
                                  <div className="d-flex justify-content-end gap-2">
                                    <button className="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close">No</button>
                                    <button className="btn btn-danger" data-bs-dismiss="modal" aria-label="Close" onClick={handleUpdateUserType} >Edit</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Tab content ends */}
                </div>
                {/* Custom tabs ends */}
                {/* Buttons starts */}

                {/* Buttons ends */}
              </div>
            </div>
          </div>
        </div>
        {/* Row ends */}
      </div>
      {/* App body ends */}
    </div>

  );
}
export default UserType;
